import React, {useContext} from "react";
import {
    GlobalDispatchContext,
    GlobalStateContext,
  } from "../../stores/GlobalContextProvider";

import Logo from "./Logo";

const Footer = () => {
    const dispatch = useContext(GlobalDispatchContext);
    const globalState = useContext(GlobalStateContext);

    const [randomCeleb, setRandomCeleb] = React.useState(Math.floor(Math.random() * 13) + 1);
    const doSameAsOnClick = () => ({ key }) => {
        if (key === "Enter") {
            setRandomCeleb(Math.floor(Math.random() * 13) + 1);
        }
    };

    return (
        <>
            <div className={`sideBar ${globalState.showInfo ? "overlayer" : ""}`}>
                {globalState.showInfo && (
                    <button
                        id="closeButton"
                        onClick={() => {
                            dispatch({ type: "SHOW_INFO", payload: false });
                        }}
                    >
                        CLOSE
                    </button>
                )}
                <div className="logo">
                    <Logo color={globalState.color ? globalState.color : "black"} />
                </div>
                <div className="copy">
                    <h2>Studio Milan Nedvěd is a graphic design practise with emphasis on typography – whether for screen or paper.</h2>
                    <br />
                    <a href="mailto:hello@mnmnmnmn.studio">E-MAIL</a>
                    <br />
                    <a href="https://www.instagram.com/nedved.studio/" rel="noreferrer" target="_blank">INSTAGRAM</a>
                    <br />
                    (+420) 77 88 07 555
                    <br />
                    <br />
                    STUDIO ADDRESS (<a href="https://maps.app.goo.gl/eccTkHKhcoF9Nt4y8" rel="noreferrer" target="_blank">MAP</a>)
                    <br />
                    Milady Horákové 851/84
                    <br />
                    170 00 Prague 7
                    <br />
                    Czech Republic, EU
                    <br />
                    <br />
                    SERVICES
                    <br />
                    Books
                    <br />
                    Exhibition Design &#38; Graphics
                    <br />
                    Identity Design
                    <br />
                    Printed Matter
                    <br />
                    Visual Campaigns
                    <br />
                    <br />
                    AWARDS
                    <br />
                    Best Book Design from all over the World
                    <br />
                    Brno Biennial International Exhibition
                    <br />
                    Designblok Awards
                    <br />
                    European Design Awards
                    <br />
                    Les Rencontres d'Arles The Book Awards
                    <br />
                    The Best Czech Photography Books Awards
                    <br />
                    The Most Beautiful Czech Books
                    <br />
                    Red Dot Design Award
                    <br />
                    <br />
                    CLIENTS
                    <br />
                    400 ASA
                    <br />
                    Absynt.sk
                    <br />
                    Alšova jihočeská galerie
                    <br />
                    ARCHITECTURA
                    <br />
                    Bigg Boss
                    <br />
                    BoysPlayNice
                    <br />
                    Czech Centres
                    <br />
                    Czech Olympic Team
                    <br />
                    City Work Architects
                    <br />
                    Dejvické divadlo
                    <br />
                    DOX
                    <br />
                    endorfilm
                    <br />
                    GHMP
                    <br />
                    Gočárova galerie
                    <br />
                    Havrlant Art Collection
                    <br />
                    J&amp;T Bank Magnus Art
                    <br />
                    Laterna Magika
                    <br />
                    Litografie Řiční
                    <br />
                    LUX nakladatelství
                    <br />
                    Max Ström Bokförlaget
                    <br />
                    Meander publishing
                    <br />
                    Město Kutná Hora
                    <br />
                    Ministry of Foreign Affairs
                    <br />
                    Moravská galerie v Brně
                    <br />
                    Museum Kampa
                    <br />
                    National Gallery Prague
                    <br />
                    National Theatre Prague
                    <br />
                    PositiF publishing
                    <br />
                    Svenstorp Art Center
                    <br />
                    Šépka architekti
                    <br />
                    Villa Pellé
                    <br />
                    Vosto5
                    <br />
                    Východočeské muzeum
                    <br />
                    wo-men publishing
                    <br />
                    ŽIJEME
                    <br />
                    <br />
                    ARTISTS
                    <br />
                    Gustav Aulehla
                    <br />
                    Norman Behrendt
                    <br />
                    Radka Bodzewicz
                    <br />
                    Natalia Dołgowska
                    <br />
                    Stanislav Diviš
                    <br />
                    Libor Fojtík
                    <br />
                    Roman Franc
                    <br />
                    David Gaberle
                    <br />
                    Fedor Gál
                    <br />
                    Dagmar Hochová
                    <br />
                    Jan Holkup
                    <br />
                    Jiří Horák
                    <br />
                    Hervé Jakubowicz
                    <br />
                    Jan Jindra
                    <br />
                    Erik Johansson
                    <br />
                    Radek Kalhous
                    <br />
                    Mirek Kaufman
                    <br />
                    kolektivní halucinace
                    <br />
                    Stanislav Kolíbal
                    <br />
                    Zdeněk Lhoták
                    <br />
                    Edita Liessner
                    <br />
                    Miroslav Machotka
                    <br />
                    Dita Pepe
                    <br />
                    Tomáš Pospěch
                    <br />
                    Bára Prášilová
                    <br />
                    Tomáš Predka
                    <br />
                    Barbora Reichová
                    <br />
                    Alexandr Skalický
                    <br />
                    Martina Sľúková
                    <br />
                    Jiří Stivín
                    <br />
                    Evžen Sobek
                    <br />
                    Kateřina Šedá
                    <br />
                    Kristýna Šormová
                    <br />
                    Karel Štědrý
                    <br />
                    Jindřich Štreit
                    <br />
                    Jana Šturdíková
                    <br />
                    TMBK
                    <br />
                    Pavel Vavroušek
                    <br />
                    Tereza Zelenková
                    <br />
                    <br />
                    <div
                        className="randomCeleb"
                        onClick={() => {
                            setRandomCeleb(Math.floor(Math.random() * 13) + 1);
                        }}
                        onKeyPress={doSameAsOnClick()}
                        title="Hall of Fame"
                        role="button"
                        tabIndex="0"
                    >
                        <img src={`/celebs/${randomCeleb}.jpg`} alt="Hall Of Fame" />
                    </div>
                    <br />
                    CV<br />Milan Nedvěd (*1978) has spent the last two decades working across digital studios, advertising agencies, and IT consultancies in Prague and London, focusing on web, digital, and screen-based design for renowned local and global brands (eg. Accenture, ČSOB, Erste Česká spořitelna, ING, Google, KangaROOS, Kraft Foods, Nike, Nokia, Pilsner Urquell, Vodafone). <br /><br />In 2012, he received an MFA from the Rhode Island School of Design (<a href="https://www.risd.edu/" rel="noreferrer" target="_blank">RISD</a>), USA. <br /><br />Since 2025 he has been the founder of the association <a href="https://www.zijeme.net/" rel="noreferrer" target="_blank">Žijeme</a>, which is a small publishing house, <a href="https://eshop.zijeme.net/" rel="noreferrer" target="_blank">e-shop</a> with original art prints and works, and a platform for cultural and art workers. Žijeme also runs public space gallery  <a href="https://www.instagram.com/pruchod.molochov" rel="noreferrer" target="_blank">Průchod Molochov</a> located in Letná district of Prague.
                    <br />
                    <br />
                    MNMNMNMN &copy; 2026
                    <br />
                    This runs on DataBitch 2.0
                    <br />
                    Do you <a href="mailto:hello@mnmnmnmn.studio?subject=I like your website, can I have one too?">like</a> it?
                    <br />
                    <br />
                    If you have read so far you deserve a <a href="https://www.youtube.com/watch?v=uJwekkbGPns" rel="noreferrer" target="_blank">cookie</a>.
                    <br />
                    <br />
                    Web development ● <a href="http://www.code8.cz/" rel="noreferrer" target="_blank">code 8</a>
                </div>
            </div>
        </>
    );
};
export default Footer;
